import React from "react";
import Icon from "components/AppIcon";
import { METRIC_ICON_STYLES } from "../dpatChartTheme";

const DpatMetricCard = ({
  title,
  value,
  unit,
  icon,
  styleIndex = 0,
  hint,
  progress,
}) => {
  const style = METRIC_ICON_STYLES[styleIndex % METRIC_ICON_STYLES.length];
  const hasProgress = Number.isFinite(progress);

  return (
    <div
      className="relative h-full overflow-hidden rounded-2xl border bg-white p-4 shadow-[0_8px_24px_rgba(22,50,90,0.05)] md:p-5"
      style={{ borderColor: `${style.color}33` }}
    >
      <div
        className="absolute inset-x-0 top-0 h-1"
        style={{ background: `linear-gradient(90deg, ${style.color}, ${style.color}88)` }}
      />
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0 flex-1">
          <p className="text-xs font-semibold uppercase tracking-[0.08em] text-slate-500">
            {title}
          </p>
          <h3 className="mt-2 text-2xl font-bold tabular-nums text-[#16325a] md:text-3xl">
            {value}
            {unit ? (
              <span className="ml-1 text-base font-medium text-slate-500 md:text-lg">
                {unit}
              </span>
            ) : null}
          </h3>
          {hint ? <p className="mt-1 text-xs text-slate-500">{hint}</p> : null}
        </div>
        <div
          className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl md:h-12 md:w-12 ${style.bg}`}
        >
          <Icon name={icon} size={20} color={style.color} className="md:h-6 md:w-6" />
        </div>
      </div>
      {hasProgress ? (
        <div className="mt-4 h-1.5 overflow-hidden rounded-full bg-slate-100">
          <div
            className="h-full rounded-full transition-all duration-500"
            style={{
              width: `${Math.max(0, Math.min(100, progress))}%`,
              backgroundColor: style.color,
            }}
          />
        </div>
      ) : (
        <div className="mt-4 h-1.5 overflow-hidden rounded-full bg-slate-100">
          <div
            className="h-full w-full rounded-full opacity-30"
            style={{ backgroundColor: style.color }}
          />
        </div>
      )}
    </div>
  );
};

export default DpatMetricCard;
